export default
{
	TERMINATE: 'terminate',
	LOST: 'lost',
	DEAD: 'dead',
	OK: 'ok'
};